<template>


    <div class="sight1_survey">

        <div v-if="sight1survey.questions.q01">

            <div class="survey_order">{{ sight1survey.order }}</div>

            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 1" >
                    <QuestionRadios :label="sight1survey.questions.q01" questionId="q01" v-model="sight1Responses.q01" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q02" questionId="q02" v-model="sight1Responses.q02" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q03" questionId="q03" v-model="sight1Responses.q03" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q04" questionId="q04" v-model="sight1Responses.q04" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q05" questionId="q05" v-model="sight1Responses.q05" @input="setResponsesNumber" />
                </div>
            </transition>
            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 2" >
                    <QuestionRadios :label="sight1survey.questions.q06" questionId="q06" v-model="sight1Responses.q06" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q07" questionId="q07" v-model="sight1Responses.q07" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q08" questionId="q08" v-model="sight1Responses.q08" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q09" questionId="q09" v-model="sight1Responses.q09" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q10" questionId="q10" v-model="sight1Responses.q10" @input="setResponsesNumber" />
                </div>
            </transition>
            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 3" >
                    <QuestionRadios :label="sight1survey.questions.q11" questionId="q11" v-model="sight1Responses.q11" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q12" questionId="q12" v-model="sight1Responses.q12" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q13" questionId="q13" v-model="sight1Responses.q13" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q14" questionId="q14" v-model="sight1Responses.q14" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q15" questionId="q15" v-model="sight1Responses.q15" @input="setResponsesNumber" />
                </div>
            </transition>
            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 4" >
                    <QuestionRadios :label="sight1survey.questions.q16" questionId="q16" v-model="sight1Responses.q16" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q17" questionId="q17" v-model="sight1Responses.q17" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q18" questionId="q18" v-model="sight1Responses.q18" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q19" questionId="q19" v-model="sight1Responses.q19" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight1survey.questions.q20" questionId="q20" v-model="sight1Responses.q20" @input="setResponsesNumber" />
                </div>
            </transition>

        </div>

    </div>

</template>

<script>
import QuestionRadios from '../questions/questionRadios'

export default {
    name: 'Sight1Survey',
    components: {
        QuestionRadios
    },
    data(){
        return {
            reponsesIdsArray: []
        }
    },
    computed: {
        sight1survey(){
            return this.$store.state.CandidateStore.sight1Survey
        },
        sight1Responses(){
            return this.$store.state.CandidateStore.sight1Responses
        },
        currentBlock(){
            if(this.reponsesIdsArray.length < 5){ return 1 }
            else if(this.reponsesIdsArray.length < 10){ return 2 }
            else if(this.reponsesIdsArray.length < 15){ return 3 }
            else if(this.reponsesIdsArray.length < 20){ return 4 }
            else{ return -1 }
        }
    },
    methods: {
        setResponsesNumber(value, qId){
            if(!this.reponsesIdsArray.includes(qId)){
                this.reponsesIdsArray.push(qId)
            }
        }
    },
    watch: {
        reponsesIdsArray: function(newVal, oldVal){
            if(newVal.length == 20){
                this.$store.commit('CandidateStore/saveResponses', { surveyName: 'sight1', survey: this.sight1Responses } )
                this.$emit('surveyCompleted', 'sight1')
            }
        }
    }
}

</script>

<style lang="scss">
</style>